import React, { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Layout.css';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';
// Import jQuery and Bootstrap JS
import 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Google Analytics
    window.gtag('js', new Date());
    window.gtag('config', 'UA-127087633-1');
  }, []);

  // Helper function to determine if a nav link is active
  const isActive = (path: string) => {
    if (path === '/' && location.pathname === '/') return 'text-dark';
    if (path !== '/' && location.pathname.toLowerCase().includes(path.replace('/', '').toLowerCase())) return 'text-dark';
    return '';
  };

  return (
    <>
      <header>
        <nav className="navbar navbar-expand-sm navbar-toggleable-sm navbar-light bg-white border-bottom box-shadow mb-3">
          <div className="container">
            <Link className="navbar-brand" to="/">
              alexjcampbell.com
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="navbar-collapse collapse d-sm-inline-flex justify-content-between">
              <ul className="navbar-nav flex-grow-1">
                <li className="nav-item">
                  <Link className={`nav-link ${isActive('/')}`} to="/">
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className={`nav-link ${isActive('/about_alex')}`} to="/about_alex">
                    About Alex
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className={`nav-link ${isActive('/flying')}`} to="/flying">
                    Flying
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className={`nav-link ${isActive('/travel')}`} to="/travel">
                    Travel
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      <div className="container">
        <main role="main" className="pb-3" style={{ maxWidth: '800px' }}>
          {children}
        </main>
      </div>

      <footer className="border-top footer text-muted">
        <div className="container">
          &copy; 2025 - Alex Campbell
        </div>
      </footer>

    </>
  );
};

export default Layout;
